import React from 'react';
import convert from 'number-to-words';
import index from '../config/index';  // Import the config file

const convertDecimalToWords = (decimalPart) => {
  if (decimalPart < 0 || decimalPart > 99) return "";

  const units = ["", "one", "two", "three", "four", "five", "six", "seven", "eight", "nine"];
  const teens = ["", "eleven", "twelve", "thirteen", "fourteen", "fifteen", "sixteen", "seventeen", "eighteen", "nineteen"];
  const tens = ["", "ten", "twenty", "thirty", "forty", "fifty", "sixty", "seventy", "eighty", "ninety"];

  if (decimalPart === 0) return units[decimalPart];
  if (decimalPart < 10) return units[Number(decimalPart)];
  if (decimalPart < 20) return teens[decimalPart - 10];

  const digit1 = Math.floor(decimalPart / 10);
  const digit2 = decimalPart % 10;
  return `${tens[digit1]}${digit2 !== 0 ? `-${units[digit2]}` : ""}`;
};

const convertAmountToWords = (amount) => {
  const currency = index.currencyName;  // Get default currency from config
  const config = index[currency] || index["GY$"];  // Use default if not found

  const { name, subunit, format, useWesternSystem } = config;
  const [integerPart, decimalPart] = String(amount).split('.');

  let formattedParts = [];
  
  if (useWesternSystem) {
    const millionPart = Math.floor(integerPart / 1000000);
    const thousandPart = Math.floor((integerPart % 1000000) / 1000);
    const remainingPart = integerPart % 1000;

    if (millionPart) formattedParts.push(`${convert.toWords(millionPart)} ${format[0]}`);
    if (thousandPart) formattedParts.push(`${convert.toWords(thousandPart)} ${format[1]}`);
    if (remainingPart) formattedParts.push(convert.toWords(remainingPart));
  } else {
    const crorePart = Math.floor(integerPart / 10000000);
    const lakhPart = Math.floor((integerPart % 10000000) / 100000);
    const thousandPart = Math.floor((integerPart % 100000) / 1000);
    const remainingPart = integerPart % 1000;

    if (crorePart) formattedParts.push(`${convert.toWords(crorePart)} ${format[0]}`);
    if (lakhPart) formattedParts.push(`${convert.toWords(lakhPart)} ${format[1]}`);
    if (thousandPart) formattedParts.push(`${convert.toWords(thousandPart)} ${format[2]}`);
    if (remainingPart) formattedParts.push(convert.toWords(remainingPart));
  }

  const integerWords = formattedParts.filter(Boolean).join(" ");
  const decimalWords = decimalPart && decimalPart !== "00" ? ` & ${convertDecimalToWords(decimalPart)}` : "";

  return {
    integerWords,
    decimalWords,
    currencyName: name,
    subunitName: subunit
  };
};

const ConvertAmountToWords = ({ amount }) => {
  const { integerWords, decimalWords, currencyName, subunitName } = convertAmountToWords(amount);

  return (
    <span>
      {integerWords} {currencyName}
      {decimalWords && (
        <>
          {decimalWords} {subunitName}
        </>
      )}
    </span>
  );
};

export default ConvertAmountToWords;
